import { useCallback, useEffect, useState } from "react";
import {
  isElectronDesktop,
  refreshDesktopSettingsCache,
} from "../desktop";

const listeners = new Set<(on: boolean) => void>();

function notify(on: boolean) {
  for (const l of listeners) {
    try {
      l(on);
    } catch {
      /* ignore */
    }
  }
}

export function useStashEnabled(): {
  stashEnabled: boolean;
  ready: boolean;
  setStashEnabled: (on: boolean) => Promise<void>;
} {
  const desktop = isElectronDesktop();
  const [stashEnabled, setOn] = useState(true);
  const [ready, setReady] = useState(!desktop);

  useEffect(() => {
    if (!desktop || !window.brexDesktop) {
      setReady(true);
      return;
    }
    let cancelled = false;
    void window.brexDesktop
      .getSettings()
      .then((s) => {
        if (cancelled) return;
        setOn(s.stashEnabled !== false);
        setReady(true);
      })
      .catch(() => {
        if (!cancelled) setReady(true);
      });
    const sub = (on: boolean) => setOn(on);
    listeners.add(sub);
    return () => {
      cancelled = true;
      listeners.delete(sub);
    };
  }, [desktop]);

  const setStashEnabled = useCallback(
    async (on: boolean) => {
      setOn(on);
      notify(on);
      if (!window.brexDesktop) return;
      const result = await window.brexDesktop.saveSettings({ stashEnabled: on });
      if (!result.ok) {
        setOn(!on);
        notify(!on);
        throw new Error(result.error || "Failed to save stash setting");
      }
      await refreshDesktopSettingsCache();
    },
    []
  );

  return { stashEnabled, ready, setStashEnabled };
}
